/**
 * PSA route edition — controls whether deferred enterprise routes exist in the build.
 *
 * - public (default): main / production — deferred URLs return generic 404 for everyone.
 * - delivery-cockpit: develop branches — admin retains access; other roles use wedge policy.
 */

export const PSA_ROUTE_EDITION_PUBLIC = 'public';
export const PSA_ROUTE_EDITION_DELIVERY_COCKPIT = 'delivery-cockpit';

/**
 * Resolve the active route edition from the React build env.
 *
 * @returns {'public'|'delivery-cockpit'}
 */
export const getPsaRouteEdition = () => {
    const raw = (process.env.REACT_APP_PSA_ROUTE_EDITION || PSA_ROUTE_EDITION_PUBLIC).trim().toLowerCase();
    if (raw === PSA_ROUTE_EDITION_DELIVERY_COCKPIT) {
        return PSA_ROUTE_EDITION_DELIVERY_COCKPIT;
    }
    return PSA_ROUTE_EDITION_PUBLIC;
};

/** @returns {boolean} True on main / public production builds. */
export const isPublicRouteEdition = () => getPsaRouteEdition() === PSA_ROUTE_EDITION_PUBLIC;

/** @returns {boolean} True on develop branches (e.g. feature/delivery-cockpit). */
export const isDeliveryCockpitRouteEdition = () => !isPublicRouteEdition();
